import React from "react";
const Card = ({ image, projectName, clientName, builtWith, year, description }) => {
    return (
        <div className="w-[300px] h-[450px] hover:scale-105 rounded-lg bg-white/30 py-2 px-2 shadow-md shadow-white relative group">
            <img src={image} alt="project foto" className="w-full rounded-lg h-full" />


            <div className="absolute h-full w-full bg-black/80 rounded-lg opacity-0 transition-all  delay-300 duration-500 left-o right-0 -bottom-3 group-hover:bottom-0 group-hover:opacity-100 flex flex-col justify-center space-y-2 px-4">
                <div className="text-gray-200 font-bold text-md">Project Name: <span className="text-yellow-500 text-md font-mono">{projectName}</span></div>
                <div className="text-gray-200 font-bold text-md">Client Name: <span className="text-yellow-500 text-md font-mono">{clientName}</span></div>
                <div className="text-gray-200 font-bold text-md">Built with: <span className="text-yellow-500 text-md font-mono">{builtWith}</span></div>
                <div className="text-gray-200 font-bold text-md">Features: <span className="text-yellow-500 text-md font-mono">{description}</span></div>
                <div className="text-gray-200 font-bold text-md">Year: <span className="text-yellow-500 text-md font-mono">{year}</span></div>
            </div>
        </div>
    );
}

export default Card;